<template>
  <modal-wrapper class="bto-sb-modalbox-scroll bto-sb-modalpopup-xl bto-sb-modalnegotiation" @close="close">
    <div class="bto-sb-modalpopup">
      <div class="bto-sb-modalpopup-title">
        <button type="button" @click.stop="close"><i class="bto-app-delete"></i></button>
        <h4>{{ t('Mobile.negotiationshort') }} - {{  negotiation.BetSlipGroupID }}</h4>
      </div>
      <div class="bto-sb-modalpopup-content">
        <div :class="negotiationClass">
          <mybets-details class="bto-sb-negotiation-content" 
            :betDetails="bet"
            @close="close"
            @rejectNegotiation="rejectNegotiation"
            @acceptNegotiation="acceptNegotiation" />
        </div>
      </div>
    </div>
  </modal-wrapper>
</template>
<script>
  import store from '../../../../store';
  import { modalFocus } from '../../../../services/toastr';
  import ModalWrapper from '../../../../components/shared/modal-wrapper';
  import MybetsDetails from '../../../../components/shared/mybets/mybet-details/web';
  import MybetsModel from '../../../../models/mybets/agent-mobile/mybet-model';

  export default {
    name: 'NegotiationModal',
    props: {
      negotiation: {
        type: Object,
        required: true,
      },
      negotiationClass: {
        type: String,
        default: 'bto-sb-negotiation-modal'
      }
    },
    data() {
      return {
        bet: null,
        interval: null,
      };
    },
    created() {
      this.bet = new MybetsModel(this.negotiation);
      const tickCb = () => {
        this.bet.tick = new Date(this.bet.timeOut) - Date.now();
      };
      tickCb();
      this.interval = setInterval(tickCb, 1000);
    },
    beforeDestroy() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
    methods: {
      rejectNegotiation({ betSlipGroupID }) {
        store.dispatch('processOffer', { isAccepted: false, betSlipGroupID, clicked: true });
      },
      acceptNegotiation({ betSlipGroupID }) {
        store.dispatch('processOffer', { isAccepted: true, betSlipGroupID, clicked: true });
      },
      close() {
        modalFocus();
        this.$emit('close');
      },
    },
    components: {
      ModalWrapper,
      MybetsDetails,
    }
  };
</script>
